import React from 'react';
import styled from 'styled-components';

import { formatNumber } from '@tager/web-core';

import { colors, fonts } from '@/constants/theme';

import { CarPricePdfProps } from './CarPricePdf.types';

function CarPricePdf({ discount, amount }: CarPricePdfProps) {
  return (
    <Component>
      {amount ? (
        <Price hasEconomyPrice={!!discount}>
          {formatNumber(amount)}{' '}
          <Currency hasEconomyPrice={!!discount}>byn</Currency>
        </Price>
      ) : null}
      {discount ? (
        <DiscountWrapper>
          <DiscountText>Экономия</DiscountText>
          <DiscountValue>{discount}</DiscountValue>
        </DiscountWrapper>
      ) : null}
    </Component>
  );
}

export default CarPricePdf;

export const Component = styled.div`
  display: flex;
  flex-direction: row;
  align-items: space-between;
  flex-wrap: wrap;
  align-items: center;
`;

export const Price = styled.div<{
  hasEconomyPrice: boolean;
}>`
  font-family: ${fonts.GrtskTera};
  font-weight: 600;
  font-size: 33px;
  display: flex;
  align-items: flex-end;
  -webkit-print-color-adjust: exact !important;
  color-adjust: exact !important;
  white-space: nowrap;
  color: ${(props) =>
    props.hasEconomyPrice ? colors.white : props.theme.black100};
  background: ${(props) =>
    props.hasEconomyPrice ? colors.blue100 : 'transparent'};
  border-radius: 2px;
  padding: ${(props) =>
    props.hasEconomyPrice ? '2px 20px 1px 8px' : '2px 20px 1px 0'};
  clip-path: polygon(
    0% 0%,
    calc(100% - 20px) 0%,
    100% 50%,
    calc(100% - 20px) 100%,
    0% 100%
  );
`;

export const Currency = styled.div<{
  hasEconomyPrice: boolean;
}>`
  font-family: ${fonts.GrtskTera};
  text-transform: ${(props) => (props.hasEconomyPrice ? 'uppercase' : 'none')};
  font-size: ${(props) => (props.hasEconomyPrice ? '16px' : '33px')};
  padding: ${(props) => (props.hasEconomyPrice ? '5px 0' : '0')};
  margin-left: 10px;
`;

const DiscountWrapper = styled.div`
  margin-left: 10px;
`;
const DiscountText = styled.div`
  font-family: ${fonts.GrtskTera};
  font-size: 10px;
`;
const DiscountValue = styled.div`
  font-family: ${fonts.GrtskTera};
  font-weight: 600;
  font-size: 20px;
  color: ${colors.blue100};
`;
